import type { AccessGovernanceMode, TenantAdminSource } from '@xobcl/types';
import type { TenantRole } from '@xobcl/types/multi-tenant-roles';

const SERVER_TENANT_ROLES: readonly TenantRole[] = ['TenantAdmin', 'Manager', 'User', 'Guest'];
const ADMIN_SOURCES: readonly TenantAdminSource[] = ['entra', 'app', 'both', 'none'];
const GOVERNANCE_MODES: readonly AccessGovernanceMode[] = ['entraOnly', 'appManaged', 'hybrid'];

/**
 * The customer-tenant role as resolved by /api/me. Anything missing or unrecognized fails closed to
 * 'User'; the client never derives TenantAdmin from raw Entra roles itself, because whether
 * QuickDial.Admin grants tenant-admin depends on the tenant's access-governance mode.
 */
export function resolveServerTenantRole(value: unknown): TenantRole {
  return SERVER_TENANT_ROLES.find((role) => role === value) ?? 'User';
}

export function isTenantAdminSource(value: unknown): value is TenantAdminSource {
  return ADMIN_SOURCES.some((source) => source === value);
}

export function isAccessGovernanceMode(value: unknown): value is AccessGovernanceMode {
  return GOVERNANCE_MODES.some((mode) => mode === value);
}
